import Vue from 'vue'
import Router from 'vue-router'
import DailycheckinRoutes from './dailycheckin'
// import Invite4cashRoutes from './invite4cash'
import RedpacketRoutes from './redpacket'
import FriendBidRoutes from './friendbid'
import UtilRoutes from './util'
import ZZAnswerGame from './zzanswerGame'
import NewMedia from './newMedia'
// import DoubleEleven from './doubleleven'
import CashPrinter from './cashprinter'
import PosterPage from './posterPage'
import BargainRushed from './bargainrushed'
import NightMarket from './nightmarket'
import QuestionSurvey from './questionSurvey'
import goodsDetailSPU from './goodsDetailSPU'
import nearbyPerson from './nearbyPerson'
import Check from './check'
import DiscoverCard from './discovercard'
import PublishRules from './publishRules'
import FreeLuckyDraw from './freeLuckyDraw'
import Test from './test'
import Birthday from './birthday'
import BindWechat from './bindWechat'
import Settings from './settings'
import ChangeBindMobile from './changeBindMobile'
import NewUserShopZone from './newUserShopZone'
import PlatformRules from './platformRules'
import CarbonScore from './carbonScore'
import B2CSeckill from './btcSeckill'
import OfficialCheck from './officialCheck'
import SecondKillDetail from './secondKillDetail'
import Withdraw from './withdraw'
import PublishMoreParameter from './publishMoreParameter'
import Complaints from './complaints'
import OneButtonPublish from './oneButtonPublish'
import BasicExperience from './basicExperience'
import NewUserTab from './NewUserTab'
import Turntable from './turntable'
import PersonalInfo from './personalInfo'
import SimpleDetail from './simpleDetail'
import MiniProgram from './miniProgram'
import Basic from './basic'
import AllCategory from './allCategory'
import ProfilePage from './profilePage'
import SimilarGoods from './similarGoods'
import InteractiveMessage from './interactiveMessage'
import OrderEvaluation from './orderEvaluation'
import ViewEvaluation from './viewEvaluation'
import WorryFreeSelling from './worryFreeSelling'
import IgnoreRemindSetting from './ignoreRemindSetting'
import SelectSaleType from './selectSaleType'
import RecommendManage from './recommendManage'
import GoodsCompare from './goodsCompare'
import MicroDetail from './microDetail'
import UserEvaluation from './userEvaluation'
import Brand from './brand'
import NaturalNewcomer from './naturalNewcomer'
import History from './history'
import CashOut from './cashOut'
import PublishH5 from './publish'
import MyCollection from './myCollection'
import LoseCard from './loseCard'
import FastSale from './fastSale'
import NewSelection from './newSelection'
import NewcomerArea from './newcomerArea'

import { initLegoData } from '@/lib/legic'

import VARS from '@/lib/vars'
import { login, setTitle } from '@/lib/sdk'
const dailycheckinRoutes: any = DailycheckinRoutes.routes
// const invite4cashRoutes: any = Invite4cashRoutes.routes
const redpacketRoutes: any = RedpacketRoutes.routes
const zzAnswerGameRoutes: any = ZZAnswerGame.routes
const friendBidRoutes: any = FriendBidRoutes.routes
const utilRoutes: any = UtilRoutes.routes
const newMedia: any = NewMedia.routes
const cashprinterRoutes: any = CashPrinter.routes
const posterPageRoutes: any = PosterPage.routes
const BargainRushedRoutes: any = BargainRushed.routes
const NightMarketRoutes: any = NightMarket.routes
const QuestionSurveyRoutes: any = QuestionSurvey.routes
const goodsDetailSPURoutes: any = goodsDetailSPU.routes
const nearbyPersonRoutes: any = nearbyPerson.routes
const check: any = Check.routes
const discoverCard: any = DiscoverCard.routes
const publishRules: any = PublishRules.routes
const freeLuckyDraw: any = FreeLuckyDraw.routes
const test: any = Test.routes
const birthday: any = Birthday.routes
const bindWechat: any = BindWechat.routes
const settings: any = Settings.routes
const changeBindMobile: any = ChangeBindMobile.routes
const newUserShopZone: any = NewUserShopZone.routes
const platformRules: any = PlatformRules.routes
const carbonScore: any = CarbonScore.routes
const b2cSeckill: any = B2CSeckill.routes
const officialCheck: any = OfficialCheck.routes
const secondKillDetail: any = SecondKillDetail.routes
const withdraw: any = Withdraw.routes
const publishMoreParameter: any = PublishMoreParameter.routes
const complaints: any = Complaints.routes
const oneButtonPublish: any = OneButtonPublish.routes
const basicExperience: any = BasicExperience.routes
const newUserTab: any = NewUserTab.routes
const turntable: any = Turntable.routes
const personalInfo: any = PersonalInfo.routes
const simpleDetail: any = SimpleDetail.routes
const miniProgram: any = MiniProgram.routes
const basic: any = Basic.routes
const allCategory: any = AllCategory.routes
const profilePage: any = ProfilePage.routes
const similarGoods: any = SimilarGoods.routes
const interactiveMessage: any = InteractiveMessage.routes
const orderEvaluation: any = OrderEvaluation.routes
const viewEvaluation: any = ViewEvaluation.routes
const worryFreeSelling: any = WorryFreeSelling.routes
const ignoreRemindSetting: any = IgnoreRemindSetting.routes
const selectSaleType: any = SelectSaleType.routes
const recommendManage: any = RecommendManage.routes
const goodsCompare: any = GoodsCompare.routes
const microDetail: any = MicroDetail.routes
const userEvaluation: any = UserEvaluation.routes
const brand: any = Brand.routes
const naturalNewcomer: any = NaturalNewcomer.routes
const history: any = History.routes
const cashOut: any = CashOut.routes
const publishH5: any = PublishH5.routes
const myCollection: any = MyCollection.routes
const loseCard: any = LoseCard.routes
const fastSale: any = FastSale.routes
const newSelection: any = NewSelection.routes
const newcomerArea: any = NewcomerArea.routes

const cutPath = (pathName) => {
  const pathReg = /[a-zA-Z_-]+/gi
  const pathNameArr = pathName.split('/')
  return pathNameArr
    .map((pathStr) => {
      let arr = null
      let path = ''
      while ((arr = pathReg.exec(pathStr)) !== null) {
        path += arr[0]
      }
      return path
    })
    .join('/')
}

Vue.use(Router)

export const routes: any = [
  // 默认路由指向签到页
  {
    path: '*',
    name: '签到领现金默认页',
    component: () => import('../views/dailycheckin/index/index.vue')
  }
].concat(
  dailycheckinRoutes,
  // invite4cashRoutes,
  zzAnswerGameRoutes,
  redpacketRoutes,
  friendBidRoutes,
  utilRoutes,
  cashprinterRoutes,
  newMedia,
  posterPageRoutes,
  BargainRushedRoutes,
  NightMarketRoutes,
  QuestionSurveyRoutes,
  goodsDetailSPURoutes,
  nearbyPersonRoutes,
  check,
  discoverCard,
  publishRules,
  freeLuckyDraw,
  test,
  birthday,
  bindWechat,
  settings,
  changeBindMobile,
  newUserShopZone,
  platformRules,
  carbonScore,
  b2cSeckill,
  officialCheck,
  secondKillDetail,
  withdraw,
  publishMoreParameter,
  complaints,
  oneButtonPublish,
  basicExperience,
  newUserTab,
  turntable,
  personalInfo,
  simpleDetail,
  basic,
  profilePage,
  miniProgram,
  allCategory,
  similarGoods,
  interactiveMessage,
  orderEvaluation,
  viewEvaluation,
  worryFreeSelling,
  ignoreRemindSetting,
  selectSaleType,
  recommendManage,
  goodsCompare,
  microDetail,
  userEvaluation,
  brand,
  naturalNewcomer,
  history,
  cashOut,
  publishH5,
  myCollection,
  loseCard,
  fastSale,
  newSelection,
  newcomerArea
)
const router = new Router({
  mode: 'history',
  base: VARS.routerBase,
  routes
})

router.beforeEach((to, from, next) => {
  // 如果设置标题，拦截后设置标题
  if (to.meta.title) {
    setTitle({ title: to.meta.title })
  }
  // initLegoData({type:`H5PLPAGES${to.path.replace(/\//g,'_').toUpperCase()}`});
  initLegoData({ type: 'H5PLPAGES' + cutPath(`${to.path.replace(/\//g, '_').toUpperCase()}`) })
  // 登录检查
  if (to.matched.some((record) => record.meta.auth)) {
    login((res) => {
      if (res.PPU) {
        next()
      }
    })
  } else {
    next()
  }
})

export default router
